import {
  SYSTEM_POSITIONTYPE_MODAL_CHANGE,
} from './constants';

export function positionTypeModalChange(visible,type) {
  return {
    type: SYSTEM_POSITIONTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_POSITIONTYPE_MODAL_CHANGE:
      return {
        ...state,
        positionTypeModalType:action.data.type,
        positionTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/positionTypeModalChange.js